import { Typography } from "@mui/material";
import { useState } from "react";
import { useCreatePlan } from "../../../hooks/useCreatePlan";
import { useMutatePlan } from "../../../hooks/useMutatePlan";
import { Plan, PlanType, RenewalStrategy, RenewalType } from "../../../models";
import { EmployerModuleType } from "../../../models/accounts/employerModuleType";
import { isLoading } from "../../../utils/isLoading";
import { useData } from "../../../utils/useData";
import { LoadingSpinner } from "../../shared/LoadingSpinner";
import { PlanFormBase, PlanFormOutput } from "../PlanFormBase";
import { PublicTransportSettingsFields } from "./PublicTransportSettingsFields";

export const PublicTransportForm = ({
  plan,
  onClose
}: {
  plan?: Plan;
  onClose: () => void;
}) => {
  const { plans, serviceSectors, employees, employer, accounts } = useData();

  const [error, setError] = useState<string | null>(null);
  var publicTransportServiceSector = serviceSectors.data!.items.find(
    // Maybe we improve this/modify this in future
    (ss) => ss.category === "Public Transport"
  );

  const mutatePlan = useMutatePlan({
    onSuccess: onClose,
    onError: (error) => console.log(error.message),
    successMessage: "Updated successfully"
  });

  const mutationCreatePlan = useCreatePlan(
    EmployerModuleType.PUBLIC_TRANSPORT,
    {
      onSuccess: () => {
        onClose();
      },
      onError: (error: Error) => {
        console.log(error.message);
      }
    }
  );

  const handlePublicTransportSave = async (values: PlanFormOutput) => {
    if (!publicTransportServiceSector) {
      setError(
        "Public transport service sector not found. Please contact support."
      );
      return;
    }

    if (!plan) {
      await mutationCreatePlan.mutate({
        name: values.name,
        serviceSectorIds: [publicTransportServiceSector!.id],
        tiers: values.tiers,
        planType: PlanType.ONE_OFF,
        renewalOptions: values.renewalOptions,
        payments: {
          isEnabled: false
        },
        purchases: {
          isEnabled: true
        },
        management: {
          canAdHocTopUp: false
        }
      });
    } else {
      await mutatePlan.mutate({
        ...plan,
        name: values.name,
        tiers: values.tiers,
        controls: {
          ...plan.controls,
          serviceSectors: [publicTransportServiceSector!]
        }
      });
    }
  };

  if (isLoading([plans, employees, accounts, serviceSectors]))
    return <LoadingSpinner />;

  return (
    <PlanFormBase
      existingPlan={plan}
      moduleType={EmployerModuleType.PUBLIC_TRANSPORT}
      isLoading={mutatePlan.isLoading}
      serviceSectors={serviceSectors.data?.items ?? []}
      onClose={onClose}
      onSave={handlePublicTransportSave}
      customDefaultValues={{
        tiers: [
          {
            id: undefined,
            name: "Default",
            amount: {
              amount: 0,
              currencyCode: employer.data?.country.currencyCode
            }
          }
        ],
        strategy: RenewalStrategy.EXPIRE,
        renewalType: RenewalType.NEVER,
        expiryPeriod: -1
      }}
    >
      <PublicTransportSettingsFields />
      {error && <Typography color="error">{error}</Typography>}
    </PlanFormBase>
  );
};
